export type UserListEvent = 'DELETE' | 'EDIT';

export const DELETE = 'DELETE';
export const EDIT = 'EDIT';
